<template>
  <div class="permissoes-page">

    <!-- ── SEÇÃO: Ações ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-lock-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Permissões</div>
          <div class="form-section__sub">Gerencie as permissões do sistema</div>
        </div>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar permissão..."
          dense outlined hide-details color="#0052A0"
          style="max-width:280px"
          class="mr-3"
        />
        <v-btn color="#0052A0" rounded elevation="0" @click="abrirModalNovo" class="px-5">
          <v-icon left color="#FFD400" small>mdi-plus</v-icon>
          <span style="color:#FFD400;font-weight:700;font-size:13px">Nova Permissão</span>
        </v-btn>
      </div>
    </div>

    <!-- ── SEÇÃO: Tabela ── -->
    <div class="form-section form-section--last">
      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        class="permissoes-table elevation-0"
        no-data-text="Sem dados"
        :footer-props="{
          'items-per-page-text': 'Registros por página: ',
          'page-text': '{0}-{1} de {2}',
          'items-per-page-all-text': 'Listar todos',
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="cell-mono">{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.label }}</td>
            <td class="text-center">
              <v-btn icon small color="#0052A0" @click="abrirModalEditar(item)" title="Editar">
                <v-icon small>mdi-square-edit-outline</v-icon>
              </v-btn>
              <v-btn icon small color="error" @click="abrirModalInativar(item)" title="Excluir">
                <v-icon small>mdi-delete-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template v-slot:no-data><span>Sem dados</span></template>
        <template v-slot:no-results>
          <span>Sua busca por "{{ search }}" não encontrou resultados.</span>
        </template>
      </v-data-table>
    </div>

    <!-- ══ MODAL: Novo / Editar Permissão ══ -->
    <v-dialog v-model="dialog" persistent max-width="900px">
      <v-card elevation="0">
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-lock-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">{{ modal.title }}</div>
            <div class="dialog-header__sub">Preencha os campos abaixo</div>
          </div>
          <v-spacer />
          <v-btn icon @click="dialog = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>

        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text class="pa-6">
            <v-row dense>
              <v-col cols="4">
                <v-text-field label="Nome" required outlined dense color="#0052A0"
                  :rules="vazio" v-model="hand.name" />
              </v-col>
              <v-col cols="8">
                <v-text-field label="Label" required outlined dense color="#0052A0"
                  :rules="vazio" v-model="hand.label" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-4 pt-0">
            <v-spacer />
            <v-btn text rounded color="#64748b" @click="dialog = false" class="px-5">Cancelar</v-btn>
            <v-btn color="#0052A0" rounded elevation="0" :loading="carregando" :disabled="!valid" @click="validate" class="px-6">
              <v-icon left color="#FFD400" small>mdi-content-save-outline</v-icon>
              <span style="color:#FFD400;font-weight:700;font-size:13px">Salvar</span>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- ══ MODAL: Excluir Permissão ══ -->
    <v-dialog v-model="modalDelete" persistent max-width="420px">
      <v-card elevation="0">
        <div class="dialog-header dialog-header--danger">
          <div class="dialog-header__icon-wrap dialog-header__icon-wrap--danger">
            <v-icon color="#dc2626">mdi-delete-alert-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Excluir permissão</div>
            <div class="dialog-header__sub">{{ hand.name }}</div>
          </div>
          <v-spacer />
          <v-btn icon @click="modalDelete = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-6">
          <p style="font-family:'Inter',sans-serif;color:#475569;font-size:0.9rem;">
            A permissão será removida permanentemente. Esta ação não pode ser desfeita.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer />
          <v-btn text rounded color="#64748b" @click="modalDelete = false" class="px-5">Cancelar</v-btn>
          <v-btn outlined rounded color="error" :loading="carregando" @click="inativaPermissao" class="px-5">
            <v-icon left small>mdi-delete-outline</v-icon>
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import helper from '../../../mixins/helper';

export default {
  components: {},
  mixins: [helper],
  data: () => ({
    dialog: false,
    modalDelete: false,
    carregando: false,
    valid: false,
    modal: { title: null, type: null },
    menu: false,
    vazio: [v => !!v || 'O campo não pode estar vazio'],
    hand: { id: null, name: null, label: null },
    list: [],
    search: '',
    headers: [
      { text: 'ID',    value: 'id',    width: '10%', align: 'start' },
      { text: 'Nome',  value: 'name',  width: '25%', align: 'start' },
      { text: 'Label', value: 'label', align: 'start' },
      { text: 'Ações', value: '',      width: '12%', align: 'center' },
    ],
  }),
  mounted() {
    this.getPemissions();
  },
  methods: {
    notificacao(title, msg, icon) {
      this.$swal({ toast: true, position: 'top-center', showConfirmButton: false, timer: 3000, icon, title, text: msg });
    },
    getPemissions() {
      this.$http.get('permissionsCrud').then(
        (response) => { this.list = response.data; },
        (response) => { console.log(response); }
      );
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.carregando = true;
        if (this.modal.type === 'novo') this.criarPermissao();
        else if (this.modal.type === 'editar') this.editarPermissao();
      }
    },
    abrirModalNovo() {
      this.modal.title = 'Nova Permissão';
      this.modal.type = 'novo';
      this.carregando = false;
      this.dialog = true;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    abrirModalEditar(item) {
      this.modal.title = 'Editar Permissão';
      this.modal.type = 'editar';
      this.hand.id = item.id;
      this.hand.name = item.name;
      this.hand.label = item.label;
      this.carregando = false;
      this.dialog = true;
    },
    abrirModalInativar(data) {
      this.hand.id = data.id;
      this.hand.name = data.name;
      this.carregando = false;
      this.modalDelete = true;
    },
    criarPermissao() {
      this.$http.post('permissionsCrud', { name: this.hand.name, label: this.hand.label }).then(
        (response) => {
          this.getPemissions();
          this.dialog = false;
          this.$refs.form.reset();
          this.$refs.form.resetValidation();
          this.notificacao('', response.body.message, 'success');
        },
        (response) => { this.carregando = false; this.notificacao('', response.body.message, 'error'); }
      );
    },
    editarPermissao() {
      this.$http.put('permissionsCrud/' + this.hand.id, { name: this.hand.name, label: this.hand.label }).then(
        (response) => {
          this.getPemissions();
          this.dialog = false;
          this.$refs.form.reset();
          this.$refs.form.resetValidation();
          this.notificacao('', response.body.message, 'success');
        },
        (response) => { this.carregando = false; this.notificacao('', response.body.message, 'error'); }
      );
    },
    inativaPermissao() {
      this.carregando = true;
      this.$http.delete('permissionsCrud/' + this.hand.id).then(
        (response) => { this.getPemissions(); this.modalDelete = false; this.notificacao('', response.body.message, 'success'); },
        (response) => { this.modalDelete = false; this.notificacao('', response.body.message, 'error'); }
      );
    },
  },
};
</script>

<style scoped>
.permissoes-page {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }

.form-section__header {
  display: flex; align-items: center; gap: 12px; flex-wrap: wrap;
}
.form-section__icon-wrap {
  width: 34px; height: 34px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.form-section__title { font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 700; color: #1e293b; }
.form-section__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 1px; }

/* ── Dialog ── */
.dialog-header {
  display: flex; align-items: center; gap: 14px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.dialog-header__icon-wrap {
  width: 38px; height: 38px; background: #e8f0fe; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.dialog-header__icon-wrap--danger { background: #fef2f2; }
.dialog-header__title { font-family: 'Inter', sans-serif; font-size: 1rem; font-weight: 700; color: #1e293b; }
.dialog-header__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; }

/* ── Tabela ── */
.permissoes-table >>> th {
  font-family: 'Inter', sans-serif !important; font-size: 0.72rem !important;
  font-weight: 700 !important; color: #64748b !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8fafc !important; padding: 10px 12px !important; white-space: nowrap;
}
.permissoes-table >>> td {
  font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important;
  color: #1e293b !important; font-weight: 400 !important;
  padding: 10px 12px !important; border-bottom: 1px solid #f1f5f9 !important;
}
.cell-mono { font-size: 0.75rem !important; color: #64748b !important; }

@media (max-width: 768px) { .permissoes-page { padding: 16px; } }
</style>
